/* ==========================================================================
   DZ COD OS v3 — Easoryn الجزائر
   منطق الواجهة: المعرض · العروض · حاسبة التوصيل · المراجعات · EasySell
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.DZ3 || {};
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); };

  /* ─────────── أدوات ─────────── */
  function money(n) {
    if (n === 0) return CFG.freeLabel || 'مجاني';
    return new Intl.NumberFormat('en-US').format(Math.round(n)) + ' ' + (CFG.currency || 'دج');
  }
  function digits(s) {
    // يحوّل الأرقام العربية-الهندية إلى غربية
    return String(s || '').replace(/[٠-٩]/g, function (d) { return d.charCodeAt(0) - 0x0660; })
                          .replace(/[۰-۹]/g, function (d) { return d.charCodeAt(0) - 0x06F0; });
  }
  function etaText(days) {
    if (!days) return '';
    if (days <= 1) return CFG.eta1 || 'التوصيل عادة في 24 ساعة';
    return (CFG.etaN || 'التوصيل عادة في %d أيام').replace('%d', days);
  }


  /* نموذج /cart/add يبقى في الصفحة بلا أي قفل.
     تحقّقنا من كود التطبيق: EasySell يزيد للسلة بـ fetch('/cart/add.js')
     وما يرسل النموذج أبداً (لا requestSubmit ولا submit ولا click).
     يعني القفل ما كان يخدم والو، وTyslo ينصح ما تتدخّلش في النموذج. */

  /* ─────────── إعلان متغيّر ─────────── */
  (function announce() {
    var slides = $$('[data-ann-slide]');
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-on');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-on');
    }, 5200);
  })();

  /* ─────────── قائمة الموبايل ─────────── */
  (function drawer() {
    var btn = $('[data-burger]'), dr = $('[data-drawer]');
    if (!btn || !dr) return;
    on(btn, 'click', function () {
      var open = dr.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  })();

  /* ─────────── الظهور عند التمرير ─────────── */
  (function reveal() {
    var els = $$('.rv');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  })();

  /* ─────────── أكورديون ─────────── */
  (function acc() {
    $$('[data-acc]').forEach(function (root) {
      var solo = root.hasAttribute('data-acc-solo');
      $$('.acc__i', root).forEach(function (item) {
        var q = $('.acc__q', item), a = $('.acc__a', item);
        if (!q || !a) return;
        on(q, 'click', function () {
          var open = item.classList.contains('is-open');
          if (solo) {
            $$('.acc__i.is-open', root).forEach(function (o) {
              o.classList.remove('is-open');
              var oa = $('.acc__a', o); if (oa) oa.style.maxHeight = null;
              var oq = $('.acc__q', o); if (oq) oq.setAttribute('aria-expanded', 'false');
            });
          }
          if (open) {
            item.classList.remove('is-open'); a.style.maxHeight = null; q.setAttribute('aria-expanded', 'false');
          } else {
            item.classList.add('is-open'); a.style.maxHeight = a.scrollHeight + 'px'; q.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
    // إعادة حساب الارتفاع عند تغيّر المقاس
    var t;
    on(window, 'resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        $$('.acc__i.is-open .acc__a').forEach(function (a) { a.style.maxHeight = a.scrollHeight + 'px'; });
      }, 160);
    });
  })();

  /* ─────────── المعرض + لايت بوكس ─────────── */
  (function gallery() {
    var root = $('[data-gal]');
    if (!root) return;
    var imgs   = $$('[data-gal-img]', root);
    var thumbs = $$('[data-gal-thumb]', root);
    var stage  = $('[data-gal-stage]', root);
    var lb     = $('[data-lb]');
    var lbImg  = lb ? $('[data-lb-img]', lb) : null;
    var lbCnt  = lb ? $('[data-lb-count]', lb) : null;
    var idx = 0;

    function show(i) {
      if (i < 0) i = imgs.length - 1;
      if (i >= imgs.length) i = 0;
      idx = i;
      imgs.forEach(function (im, n) { im.hidden = n !== i; });
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (t, n) {
      on(t, 'click', function () { show(n); });
    });

    if (lb && lbImg) {
      function openLb() {
        lbImg.src = imgs[idx].currentSrc || imgs[idx].src;
        lbImg.alt = imgs[idx].alt || '';
        if (lbCnt) lbCnt.textContent = (idx + 1) + ' / ' + imgs.length;
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
      }
      function closeLb() { lb.hidden = true; document.body.style.overflow = ''; }
      function step(d) { show(idx + d); lbImg.src = imgs[idx].currentSrc || imgs[idx].src; if (lbCnt) lbCnt.textContent = (idx + 1) + ' / ' + imgs.length; }

      on(stage, 'click', openLb);
      on($('[data-lb-x]', lb), 'click', closeLb);
      on($('[data-lb-prev]', lb), 'click', function () { step(-1); });
      on($('[data-lb-next]', lb), 'click', function () { step(1); });
      on(lb, 'click', function (e) { if (e.target === lb) closeLb(); });
      on(document, 'keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLb();
        // RTL: السهم الأيسر = التالي
        if (e.key === 'ArrowLeft') step(1);
        if (e.key === 'ArrowRight') step(-1);
      });
    }

    // سحب على الموبايل
    var x0 = null;
    on(stage, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    on(stage, 'touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 46) { show(idx + (dx < 0 ? 1 : -1)); }
      x0 = null;
    }, { passive: true });

    show(0);
  })();

  /* ─────────── العروض + الشريط الثابت ─────────── */
  (function offers() {
    var cards = $$('[data-offer]');
    var qtyIn = $('[data-atc-qty]');
    var stickyNow = $('[data-sticky-now]');
    var stickyWas = $('[data-sticky-was]');
    if (!cards.length) return;

    function pick(card) {
      cards.forEach(function (c) {
        var on_ = c === card;
        c.classList.toggle('is-on', on_);
        c.setAttribute('aria-checked', on_ ? 'true' : 'false');
      });
      /* ما نبعثوش حتى حدث change هنا — التطبيق يلقط change على
         input[name="quantity"] ويزيد للسلة. نكتبو القيمة برك، والتطبيق
         يقراها بالـ selector كي تتحل النافذة. */
      var vId = card.getAttribute('data-variant');
      if (vId) {
        var vIn = document.getElementById('dz3-variant-id');
        if (vIn) { vIn.value = vId; vIn.setAttribute('value', vId); }
      }
      var q = card.getAttribute('data-qty') || '1';
      if (qtyIn) { qtyIn.value = q; qtyIn.setAttribute('value', q); }
      var p = card.getAttribute('data-price');
      var w = card.getAttribute('data-compare');
      if (stickyNow && p) stickyNow.textContent = money(parseFloat(p));
      if (stickyWas) {
        if (w && parseFloat(w) > 0) { stickyWas.textContent = money(parseFloat(w)); stickyWas.hidden = false; }
        else stickyWas.hidden = true;
      }
      window.DZ3_OFFER = { qty: parseInt(q, 10), price: parseFloat(p || 0) };
      document.dispatchEvent(new CustomEvent('dz3:offer', { detail: window.DZ3_OFFER }));
    }

    cards.forEach(function (c) {
      on(c, 'click', function () { pick(c); });
      on(c, 'keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pick(c); }
      });
    });

    var def = cards.filter(function (c) { return c.hasAttribute('data-default'); })[0] || cards[0];
    pick(def);
  })();

  /* ─────────── الشريط الثابت: الظهور ─────────── */
  (function stickyBar() {
    var bar = $('[data-sticky]');
    if (!bar) return;
    var after = CFG.stickyAfter || 560;
    function sync() {
      var show = window.scrollY > after;
      bar.classList.toggle('is-on', show);
      document.documentElement.style.setProperty('--sticky-h', show && window.innerWidth <= 900 ? (bar.offsetHeight + 'px') : '0px');
    }
    on(window, 'scroll', sync, { passive: true });
    on(window, 'resize', sync);
    sync();
  })();

  /* ─────────── حاسبة التوصيل ─────────── */
  (function calc() {
    var root = $('[data-calc]');
    if (!root || !window.DZ_W) return;

    var selW = $('[data-calc-w]', root);
    var selC = $('[data-calc-c]', root);
    var modeH = $('[data-mode="home"]', root);
    var modeD = $('[data-mode="desk"]', root);
    var out   = $('[data-calc-out]', root);
    var outMode = $('[data-out-mode]', root);
    var outPrice = $('[data-out-price]', root);
    var outEta = $('[data-out-eta]', root);
    var outSave = $('[data-out-save]', root);
    var mode = 'desk';
    var communesLoaded = false;

    // تعبئة الولايات
    var frag = document.createDocumentFragment();
    window.DZ_W.forEach(function (w) {
      var o = document.createElement('option');
      o.value = w[0];
      o.textContent = (w[0] < 10 ? '0' + w[0] : w[0]) + ' — ' + w[1];
      frag.appendChild(o);
    });
    if (selW) selW.appendChild(frag);

    function wilaya(id) {
      for (var i = 0; i < window.DZ_W.length; i++) if (window.DZ_W[i][0] === parseInt(id, 10)) return window.DZ_W[i];
      return null;
    }
    // تجاوزات الأسعار من إعدادات الثيم: "16:400:300"
    function override(id) {
      var raw = CFG.shippingOverrides || '';
      if (!raw) return null;
      var lines = raw.split(/\n|,/);
      for (var i = 0; i < lines.length; i++) {
        var p = lines[i].trim().split(':');
        if (p.length >= 3 && parseInt(p[0], 10) === parseInt(id, 10)) {
          return { home: parseFloat(p[1]), desk: parseFloat(p[2]) };
        }
      }
      return null;
    }

    function loadCommunes(cb) {
      if (communesLoaded || window.DZ_C) { communesLoaded = true; return cb(); }
      var src = document.documentElement.getAttribute('data-communes');
      if (!src) return cb();
      var s = document.createElement('script');
      s.src = src;
      s.onload = function () { communesLoaded = true; cb(); };
      s.onerror = function () { cb(); };
      document.head.appendChild(s);
    }

    function fillCommunes(id) {
      if (!selC) return;
      selC.innerHTML = '<option value="">' + (CFG.communeLabel || 'اختر البلدية') + '</option>';
      var list = window.DZ_C ? window.DZ_C[String(parseInt(id, 10))] : null;
      if (!list) { selC.disabled = true; return; }
      var f = document.createDocumentFragment();
      list.forEach(function (c) {
        var o = document.createElement('option'); o.value = c; o.textContent = c; f.appendChild(o);
      });
      selC.appendChild(f);
      selC.disabled = false;
    }

    function render() {
      var id = selW && selW.value;
      if (!id) { if (out) out.classList.remove('is-on'); return; }
      var w = wilaya(id);
      if (!w) return;
      var ov = override(id);
      var home = ov ? ov.home : w[3];
      var desk = ov ? ov.desk : w[4];
      var days = w[5];
      var bump = parseFloat(CFG.shippingBump || 0);

      // بعض الولايات بلا مكتب توصيل
      var noDesk = (desk === null || desk === 0 || desk === undefined);
      if (modeD) {
        modeD.disabled = noDesk;
        modeD.classList.toggle('hide', false);
        var dx = $('[data-desk-note]', modeD);
        if (dx) dx.textContent = noDesk ? 'ما كاينش مكتب توصيل في هاذ الولاية' : 'أرخص — تروح تجيبه من المكتب';
      }
      if (noDesk && mode === 'desk') setMode('home');

      var base = mode === 'home' ? home : desk;
      if (base === null || base === undefined) base = home;
      var price = base + bump;

      // توصيل مجاني حسب العرض المختار / العتبة
      var free = false;
      var o = window.DZ3_OFFER;
      if (root.getAttribute('data-free-offer') === '1' && o && o.qty >= parseInt(root.getAttribute('data-free-qty') || '99', 10)) free = true;
      var thr = parseFloat(CFG.freeFrom || 0);
      if (thr > 0 && o && o.price >= thr) free = true;

      if (outMode) outMode.textContent = mode === 'home' ? 'توصيل للدار' : 'مكتب التوصيل';
      if (outPrice) {
        outPrice.textContent = free ? (CFG.freeLabel || 'مجاني') : money(price);
        outPrice.classList.toggle('result__free', free);
      }
      if (outEta) outEta.textContent = etaText(days);
      if (outSave) {
        var diff = (home + bump) - (desk + bump);
        if (mode === 'desk' && !noDesk && diff > 0 && !free) {
          outSave.textContent = 'ربحت ' + money(diff) + ' مقارنة بالتوصيل للدار';
          outSave.hidden = false;
        } else outSave.hidden = true;
      }
      if (out) out.classList.add('is-on');
    }

    function setMode(m) {
      mode = m;
      if (modeH) modeH.classList.toggle('is-on', m === 'home');
      if (modeD) modeD.classList.toggle('is-on', m === 'desk');
      render();
    }

    /* ══ حاجز مهم ══
       EasySell مركّب سامع عام على document:
         document.addEventListener('change', e => e.target.matches(SEL) && addVariantToCart())
       و SEL فيه «select:not(.es-select)» — يعني قوائم الولاية والبلدية تاع حاسبتنا
       داخلين فيه. و addVariantToCart يدير fetch('/cart/add.js') حقيقي.
       النتيجة: كل مرة الزبون يبدّل الولاية = علبة زايدة في سلة Shopify.
       زبون يختار ولاية + بلدية = علبتين زايدين قبل ما يفتح الاستمارة أصلاً.
       نوقفو الحدث على العنصر نفسو — السامعين تاعنا على نفس العنصر ما يتأثروش،
       وما نلمسوش حقول التطبيق (هي في نافذة منفصلة وعندها .es-select). */
    var stopES = function (e) { e.stopPropagation(); };
    if (selW) selW.addEventListener('change', stopES);
    if (selC) selC.addEventListener('change', stopES);

    on(selW, 'change', function () {
      loadCommunes(function () { fillCommunes(selW.value); render(); });
    });
    on(selC, 'change', render);
    on(modeH, 'click', function () { setMode('home'); });
    on(modeD, 'click', function () { if (!modeD.disabled) setMode('desk'); });
    on(document, 'dz3:offer', render);
    setMode('desk');
  })();

  /* ─────────── المراجعات: فلترة + المزيد ─────────── */
  (function reviews() {
    var root = $('[data-rev]');
    if (!root) return;
    var cards = $$('[data-rev-c]', root);
    var chips = $$('[data-rev-chip]', root);
    var bars  = $$('[data-rev-bar]', root);
    var more  = $('[data-rev-more]', root);
    var step  = parseInt(root.getAttribute('data-step') || '6', 10);
    var shown = step;
    var filter = 0;

    function paint() {
      var n = 0;
      cards.forEach(function (c) {
        var s = parseInt(c.getAttribute('data-stars') || '5', 10);
        var match = !filter || s === filter;
        if (match && n < shown) { c.hidden = false; n++; }
        else c.hidden = true;
      });
      var total = cards.filter(function (c) {
        var s = parseInt(c.getAttribute('data-stars') || '5', 10);
        return !filter || s === filter;
      }).length;
      if (more) more.hidden = shown >= total;
      chips.forEach(function (ch) {
        ch.classList.toggle('is-on', parseInt(ch.getAttribute('data-rev-chip'), 10) === filter);
      });
      bars.forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.getAttribute('data-rev-bar'), 10) === filter);
      });
    }
    function setFilter(v) { filter = (filter === v) ? 0 : v; shown = step; paint(); }

    chips.forEach(function (ch) { on(ch, 'click', function () { setFilter(parseInt(ch.getAttribute('data-rev-chip'), 10)); }); });
    bars.forEach(function (b) { on(b, 'click', function () { setFilter(parseInt(b.getAttribute('data-rev-bar'), 10)); }); });
    on(more, 'click', function () { shown += step; paint(); });
    paint();
  })();

  /* ─────────── حالة نافذة EasySell ───────────
     نزيدو class على <html> كي تكون النافذة محلولة، باش:
       • شريط الثيم تاعنا يختفي (ما يتصادمش معاها على الهاتف)
       • شريط التطبيق الأسود يرجع كيما كان (خبّيناه وقت التصفّح برك) */
  (function esOpenState() {
    var root = document.documentElement;
    var SEL = '#easysell-modal,.es-modal,#easysell';
    var raf = 0, watched = null;
    function shown() {
      var l = document.querySelectorAll(SEL), i, cs;
      for (i = 0; i < l.length; i++) {
        cs = getComputedStyle(l[i]);
        if (cs.display !== 'none' && cs.visibility !== 'hidden') return true;
      }
      return false;
    }
    function sync() { raf = 0; root.classList.toggle('es-open', shown()); }
    function queue() { if (!raf) raf = requestAnimationFrame(sync); }
    function attach() {
      var el = document.querySelector(SEL);
      if (!el || el === watched) return;
      watched = el;
      try { new MutationObserver(queue).observe(el, { attributes: true, attributeFilter: ['style', 'class'] }); } catch (e) {}
      queue();
    }
    try { new MutationObserver(function () { attach(); queue(); }).observe(document.body, { childList: true }); } catch (e) {}
    document.addEventListener('ES_FORM_CLOSED', queue);
    window.addEventListener('load', queue);
    attach(); sync();
  })();

  /* ─────────── لوحة تشخيص للهاتف ───────────
     تتفعّل برك بـ ?dzdebug=1 في الرابط. الزبون العادي ما يشوفها أبداً.
     تخدم كي ما تقدرش تحلّ Console على التيليفون. */
  (function debugPanel() {
    try {
      if (!/[?&]dzdebug=1/.test(location.search) && location.hash !== '#dzdebug') return;
    } catch (e) { return; }

    var log = [], spurious = 0, errs = 0;
    var SEL = 'input[type="checkbox"]:not(.es-checkbox),input[type="radio"]:not(.es-radio),' +
              'select:not(.es-select),.variant-input,button,#Quantity,input[name="quantity"],[name="updates[]"]';

    document.addEventListener('change', function (e) {
      try { if (e.target.matches(SEL)) { spurious++; log.push('⚠ change → التطبيق راح يزيد للسلة: ' + (e.target.id || e.target.tagName)); } } catch (x) {}
    });
    window.addEventListener('error', function (e) { errs++; log.push('✖ ' + (e.message || '')); paint(); });
    window.addEventListener('unhandledrejection', function (e) {
      errs++; log.push('✖ promise: ' + ((e.reason && (e.reason.message || e.reason)) || '')); paint();
    });

    var of_ = window.fetch;
    window.fetch = function () {
      var u = String((arguments[0] && arguments[0].url) || arguments[0] || '');
      var pr = of_.apply(this, arguments);
      if (/easysell|tyslo|geteasysell|cart\/add|cart\.js/i.test(u)) {
        pr.then(function (r) {
          log.push((r.ok ? '✔ ' : '✖ ') + r.status + ' ' + u.replace(/^https?:\/\/[^/]+/, '').slice(0, 58));
          r.clone().text().then(function (t) {
            if (!r.ok) log.push('   ↳ ' + t.slice(0, 180));
            paint();
          }).catch(function () { paint(); });
        }).catch(function (e) { log.push('✖ فشل الاتصال: ' + u.slice(0, 50)); paint(); });
      }
      return pr;
    };

    var box, body;
    function build() {
      box = document.createElement('div');
      box.setAttribute('dir', 'rtl');
      box.style.cssText = 'position:fixed;inset-inline:0;inset-block-end:0;max-height:52vh;overflow:auto;' +
        'z-index:2147483647;background:#0b1512;color:#d6f5e6;font:12px/1.6 ui-monospace,monospace;' +
        'padding:10px 12px;border-block-start:2px solid #2D7A5F;box-shadow:0 -6px 24px rgba(0,0,0,.5)';
      var bar = document.createElement('div');
      bar.style.cssText = 'display:flex;gap:8px;align-items:center;margin-block-end:8px';
      bar.innerHTML = '<b style="color:#7ee0b0">تشخيص EasySell</b>';
      var cp = document.createElement('button');
      cp.textContent = 'نسخ'; cp.style.cssText = 'margin-inline-start:auto;background:#2D7A5F;color:#fff;border:0;border-radius:6px;padding:4px 12px;font:inherit';
      cp.onclick = function () {
        var t = body.innerText;
        if (navigator.clipboard) navigator.clipboard.writeText(t).then(function(){ cp.textContent='تنسخ ✓'; });
        else { var a = document.createElement('textarea'); a.value = t; document.body.appendChild(a); a.select(); document.execCommand('copy'); a.remove(); cp.textContent = 'تنسخ ✓'; }
      };
      var x = document.createElement('button');
      x.textContent = '✕'; x.style.cssText = 'background:#333;color:#fff;border:0;border-radius:6px;padding:4px 10px;font:inherit';
      x.onclick = function () { box.remove(); };
      bar.appendChild(cp); bar.appendChild(x);
      body = document.createElement('div');
      box.appendChild(bar); box.appendChild(body);
      document.body.appendChild(box);
    }

    var cartCount = '…', cartTotal = '…';
    function readCart() {
      of_('/cart.js', { headers: { accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          cartCount = c.item_count;
          cartTotal = (c.total_price / 100).toFixed(0);
          paint();
        }).catch(function () { cartCount = '؟'; paint(); });
    }

    function paint() {
      if (!box) return;
      var H = window.EasySellHelpers, vid = '—', qty = '—';
      try { if (H) { vid = H.getVariantId(); qty = H.getVariantQuantity(vid); } } catch (e) {}
      var f = document.getElementById('dz3-variant-id'), q = document.getElementById('dz3-qty');
      var rows = [
        ['التطبيق محمّل', H ? 'نعم' : 'لا ← app embed مطفي'],
        ['variant في الثيم', f ? (f.value || 'فارغ') : '—'],
        ['الكمية في الثيم', q ? (q.value || 'فارغ') : '—'],
        ['variant اللي يشوفو التطبيق', vid],
        ['الكمية اللي يشوفها', qty],
        ['سلة Shopify', cartCount + ' سلعة · ' + cartTotal + ' دج'],
        ['أحداث change طفيلية', spurious + (spurious ? '  ⚠ كل وحدة = علبة زايدة' : '  ✔')],
        ['أخطاء JS', errs],
        ['نافذة التطبيق', document.documentElement.classList.contains('es-open') ? 'محلولة' : 'مسكّرة'],
        ['أزرار الطلب', document.querySelectorAll('.es-popup-button-overwrite').length]
      ];
      body.innerHTML = rows.map(function (r) {
        return '<div style="display:flex;gap:10px"><span style="color:#8fbfa8;min-width:11em">' + r[0] +
               '</span><b style="color:#fff">' + r[1] + '</b></div>';
      }).join('') +
      (log.length ? '<div style="margin-block-start:8px;padding-block-start:8px;border-block-start:1px solid #234">' +
        log.slice(-14).map(function (l) { return '<div style="color:#ffd9a0;word-break:break-all">' + l.replace(/</g, '&lt;') + '</div>'; }).join('') + '</div>' : '');
    }

    function boot() { build(); readCart(); paint(); setInterval(readCart, 4000); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  /* ─────────── تتبّع الطلب (رابط خارجي) ─────────── */
  (function track() {
    var f = $('[data-track]');
    if (!f) return;
    on(f, 'submit', function (e) {
      e.preventDefault();
      var inp = $('[data-track-in]', f);
      var err = $('[data-track-err]', f);
      var v = digits(inp && inp.value).trim();
      if (!v || v.length < 5) { if (err) { err.hidden = false; } return; }
      if (err) err.hidden = true;
      var base = f.getAttribute('data-track-url') || '';
      if (base) window.open(base.replace('{code}', encodeURIComponent(v)), '_blank', 'noopener');
    });
  })();

  /* ─────────── EasySell: تشخيص + احتياط ─────────── */
  (function easysell() {
    var box = $('[data-es-box]');
    if (!box) return;
    var fb = $('[data-es-fallback]', box);
    // إذا ما ركّبش التطبيق النموذج خلال 6 ثوانٍ، نعرض بديل الهاتف/واتساب
    setTimeout(function () {
      var hook = document.getElementById('es-form-hook');
      var mounted = document.getElementById('easysell') || document.getElementById('es-form') ||
                    (hook && hook.children.length > 0);
      if (!mounted && fb) fb.hidden = false;
    }, 6000);
  })();

  /* ─────────── بكسلات الثيم (اختيارية — EasySell يطلق الشراء بنفسه) ─────────── */
  (function pixels() {
    if (!CFG.pixels) return;
    var fired = false;
    function lead() {
      if (fired) return; fired = true;
      var ev = CFG.leadEvent || 'InitiateCheckout';
      try { if (window.ttq) window.ttq.track(ev === 'Lead' ? 'SubmitForm' : 'InitiateCheckout'); } catch (e) {}
      try { if (window.snaptr) window.snaptr('track', 'START_CHECKOUT'); } catch (e) {}
    }
    $$('.es-popup-button-overwrite').forEach(function (b) { on(b, 'click', lead); });
  })();

  /* ─────────── التقييم التلقائي (يُحسب من الآراء الحقيقية في الصفحة) ─────────── */
  (function autoRating() {
    var strip = document.querySelector('[data-rating-auto]');
    if (!strip) return;
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-rev-c]'));
    if (!cards.length) return;                       // بلا آراء = بلا تقييم معروض
    var sum = 0, n = 0;
    cards.forEach(function (c) {
      var s = parseInt(c.getAttribute('data-stars') || '0', 10);
      if (s > 0) { sum += s; n++; }
    });
    if (!n) return;
    var avg = sum / n;
    var box = strip.querySelector('[data-rating-stars]');
    if (box) {
      var html = '';
      for (var k = 1; k <= 5; k++) {
        var off = k > Math.round(avg) ? ' class="is-off"' : '';
        html += '<i' + off + '><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m12 2.6 2.9 5.9 6.5.9-4.7 4.6 1.1 6.5-5.8-3-5.8 3 1.1-6.5L2.6 9.4l6.5-.9z"/></svg></i>';
      }
      box.innerHTML = html;
      box.setAttribute('role', 'img');
      box.setAttribute('aria-label', avg.toFixed(1) + ' من 5');
    }
    var a = strip.querySelector('[data-rating-avg]');
    if (a) a.textContent = avg.toFixed(1) + '/5';
    var c2 = strip.querySelector('[data-rating-count]');
    if (c2) {
      var word = n === 1 ? 'رأي واحد' : n === 2 ? 'رأيين' : (n <= 10 ? n + ' آراء' : n + ' رأياً');
      c2.textContent = '· من ' + word;
    }
    strip.hidden = false;
    strip.style.cursor = 'pointer';
    strip.addEventListener('click', function () {
      var t = document.querySelector('[data-rev]');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  })();

  /* ─────────── التقييم التلقائي (يُحسب من الآراء الحقيقية في الصفحة) ─────────── */
  (function autoRating() {
    var strip = document.querySelector('[data-rating-auto]');
    if (!strip) return;
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-rev-c]'));
    if (!cards.length) return;                       // بلا آراء = بلا تقييم معروض
    var sum = 0, n = 0;
    cards.forEach(function (c) {
      var s = parseInt(c.getAttribute('data-stars') || '0', 10);
      if (s > 0) { sum += s; n++; }
    });
    if (!n) return;
    var avg = sum / n;
    var box = strip.querySelector('[data-rating-stars]');
    if (box) {
      var html = '';
      for (var k = 1; k <= 5; k++) {
        var off = k > Math.round(avg) ? ' class="is-off"' : '';
        html += '<i' + off + '><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m12 2.6 2.9 5.9 6.5.9-4.7 4.6 1.1 6.5-5.8-3-5.8 3 1.1-6.5L2.6 9.4l6.5-.9z"/></svg></i>';
      }
      box.innerHTML = html;
      box.setAttribute('role', 'img');
      box.setAttribute('aria-label', avg.toFixed(1) + ' من 5');
    }
    var a = strip.querySelector('[data-rating-avg]');
    if (a) a.textContent = avg.toFixed(1) + '/5';
    var c2 = strip.querySelector('[data-rating-count]');
    if (c2) {
      var word = n === 1 ? 'رأي واحد' : n === 2 ? 'رأيين' : (n <= 10 ? n + ' آراء' : n + ' رأياً');
      c2.textContent = '· من ' + word;
    }
    strip.hidden = false;
    strip.style.cursor = 'pointer';
    strip.addEventListener('click', function () {
      var t = document.querySelector('[data-rev]');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  })();

})();